/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Payment_DateInputs */

const en_case_payment_payment_date = /** @type {(inputs: Case_Payment_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment date`)
};

const pt_br2_case_payment_payment_date = /** @type {(inputs: Case_Payment_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data do pagamento`)
};

/**
* | output |
* | --- |
* | "Payment date" |
*
* @param {Case_Payment_Payment_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_payment_date = /** @type {((inputs?: Case_Payment_Payment_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Payment_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_payment_date(inputs)
	return pt_br2_case_payment_payment_date(inputs)
});